import { createFileRoute, redirect } from '@tanstack/react-router';

/** Bare /owner opens the shared role-aware dashboard. */
export const Route = createFileRoute('/_authed/owner/')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
